import { injectable, inject } from 'inversify';

import { History } from '@vk-hr-tek/core/history';
import { RoleService } from '@vk-hr-tek/core/http';

import { CommunityRouter } from '../../../community/types';
import { modules } from '../../modules';

@injectable()
export class CommunityRouterService implements CommunityRouter {
  constructor(
    @inject(History) private history: History,
    @inject(RoleService) private readonly role: RoleService,
  ) {}

  goToDetail(id: string, slug: string) {
    this.history.push(`/${modules.community.basename}/${id}/${slug}`);
  }

  goToEdit(id: string, slug: string, query: string, hash?: string) {
    let search = '';

    if (query && query !== '?') {
      search = query.startsWith('?') ? query : `?${query}`;
    }

    const location: {
      pathname: string;
      search: string;
      hash?: string;
    } = {
      pathname: `/${modules.community.basename}/${id}/${slug}/edit`,
      search,
    };

    if (hash) {
      location.hash = hash.startsWith('#') ? hash : `#${hash}`;
    }

    this.history.push(location);
  }

  goToList(query?: string) {
    if (!query || query === '?') {
      this.history.push(`/${modules.community.basename}`);
      return;
    }

    this.history.push({
      pathname: `/${modules.community.basename}`,
      search: query.startsWith('?') ? query : `?${query}`,
    });
  }

  goToCreate(accountId: string) {
    this.history.push({
      pathname: `${modules.community.basename}/create`,
      search: `?account_id=${accountId}`,
    });
  }

  goToInvite(id: string, slug: string, query: string) {
    if (!query || query === '?') {
      this.history.push(`/${modules.community.basename}/${id}/${slug}/invite`);
      return;
    }

    this.history.push({
      pathname: `/${modules.community.basename}/${id}/${slug}/invite`,
      search: query.startsWith('?') ? query : `?${query}`,
    });
  }

  goToAutoJoinSettings(id: string, slug: string, query?: string) {
    if (!query || query === '?') {
      this.history.push(
        `/${modules.community.basename}/${id}${slug ? `/${slug}` : ''}/autoJoinSettings`,
      );
      return;
    }

    this.history.push({
      pathname: `/${modules.community.basename}/${id}${slug ? `/${slug}` : ''}/autoJoinSettings`,
      search: query.startsWith('?') ? query : `?${query}`,
    });
  }

  goToManageUsers(id: string, slug: string, query?: string): void {
    if (!query || query === '?') {
      this.history.push(
        `/${modules.community.basename}/${id}${slug ? `/${slug}` : ''}/manage`,
      );
      return;
    }

    this.history.push({
      pathname: `/${modules.community.basename}/${id}${slug ? `/${slug}` : ''}/manage`,
      search: query.startsWith('?') ? query : `?${query}`,
    });
  }

  goToCommunityUsers(id: string, slug: string, query?: string) {
    if (!query || query === '?') {
      this.history.push(
        `/${modules.community.basename}/${id}${slug ? `/${slug}` : ''}/users`,
      );
      return;
    }

    this.history.push({
      pathname: `/${modules.community.basename}/${id}${slug ? `/${slug}` : ''}/users`,
      search: query.startsWith('?') ? query : `?${query}`,
    });
  }

  goToPostDetail(id: string, slug: string, postId: string): void {
    window.open(
      `/${modules.community.basename}/${id}/${slug}/post/${postId}`,
      '_blank',
    );
  }
}
